import {colors} from './dark.colors.style';
import {fontSize} from './fontSize.style';
import {padding} from './padding.style';

export const coreStyles = {
  colors,
  fontSize,
  padding
};



// WEBPACK FOOTER //
// ./styles/core/index.style.js